import type { SvgIconComponent } from "@mui/icons-material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import TableChartIcon from "@mui/icons-material/TableChart";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ImageIcon from "@mui/icons-material/Image";

export interface FileTypeStyle {
  Icon: SvgIconComponent;
  iconColor: string;
  iconBg: string;
}

export function getFileExtension(filename: string): string {
  const i = filename.lastIndexOf(".");
  if (i < 0 || i === filename.length - 1) return "";
  return filename.slice(i + 1).toLowerCase();
}

/** Visual identity per extension for generated / chat documents */
export function getFileTypeStyle(filename: string): FileTypeStyle {
  const ext = getFileExtension(filename);
  switch (ext) {
    case "pdf":
      return {
        Icon: PictureAsPdfIcon,
        iconColor: "#b91c1c",
        iconBg: "rgba(185, 28, 28, 0.12)",
      };
    case "doc":
    case "docx":
      return {
        Icon: DescriptionIcon,
        iconColor: "#1d4ed8",
        iconBg: "rgba(29, 78, 216, 0.12)",
      };
    case "ppt":
    case "pptx":
      return {
        Icon: SlideshowIcon,
        iconColor: "#c2410c",
        iconBg: "rgba(194, 65, 12, 0.12)",
      };
    case "txt":
    case "md":
    case "csv":
      return {
        Icon: TextSnippetIcon,
        iconColor: "#047857",
        iconBg: "rgba(4, 120, 87, 0.12)",
      };
    case "xls":
    case "xlsx":
      return {
        Icon: TableChartIcon,
        iconColor: "#15803d",
        iconBg: "rgba(21, 128, 61, 0.12)",
      };
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "webp":
    case "svg":
      return {
        Icon: ImageIcon,
        iconColor: "#7c3aed",
        iconBg: "rgba(124, 58, 237, 0.12)",
      };
    default:
      return {
        Icon: InsertDriveFileIcon,
        iconColor: "#4b5563",
        iconBg: "rgba(75, 85, 99, 0.12)",
      };
  }
}

export function isPdfExtension(filename: string): boolean {
  return getFileExtension(filename) === "pdf";
}

export function isTextPreviewExtension(filename: string): boolean {
  const e = getFileExtension(filename);
  return e === "txt" || e === "md" || e === "csv";
}

export function isOfficePreviewExtension(filename: string): boolean {
  const e = getFileExtension(filename);
  return (
    e === "doc" ||
    e === "docx" ||
    e === "ppt" ||
    e === "pptx" ||
    e === "xls" ||
    e === "xlsx"
  );
}
